module.exports = __webpack_public_path__ + "img/pin_h4b.5b024d01.png";